export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0027s_0000_Black-&-White-3.78113839.png";